import AppVideo from './AppVideo.vue'

export default {
    'app-video': AppVideo
}
